const READ_ONLY = 'read_only';

const UserGroups = { READ_ONLY };

export default UserGroups;
